import React, { useEffect, useState } from "react";
import { CalendarCheck, CalendarDays, CalendarX } from "lucide-react";
import dayjs from "dayjs";
import moment from "moment";

const TONES = {
  blue: { tile: "bg-[#EFF6FF] text-[#2563EB]", badge: "bg-[#EFF6FF] text-[#2563EB]" },
  teal: { tile: "bg-[#F0FDFA] text-[#0D9488]", badge: "bg-[#ECFDF5] text-[#059669]" },
  orange: { tile: "bg-[#FFF7ED] text-[#EA580C]", badge: "bg-[#FFF7ED] text-[#EA580C]" },
};

const StatCard = ({ icon: Icon, tone, badge, value, title, sub1, sub2 }) => (
  <div className="flex flex-col justify-between h-full bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl p-[14px] w-full shadow-sm hover:shadow-md transition-shadow">
    <div className="flex items-start justify-between mb-2">
      <div
        className={`flex items-center justify-center w-[34px] h-[34px] rounded-lg ${TONES[tone].tile}`}
      >
        <Icon size={17} />
      </div>
      {badge ? (
        <span
          className={`px-2 py-0.5 rounded-full text-[12px] font-semibold font-poppins ${TONES[tone].badge}`}
        >
          {badge}
        </span>
      ) : null}
    </div>
    <div>
      <div className="text-[24px] leading-tight font-bold text-[#171717] font-poppins">
        {value}
      </div>
      <div className="mt-0.5 text-[12px] uppercase tracking-wide font-medium text-[#64748B] font-poppins">
        {title}
      </div>
    </div>
  </div>
);

const Index = ({ filteredAppointment }) => {
  const [todayAppointments, setTodayAppointments] = useState([]);
  const [totalAppointments, setTotalAppointments] = useState(0);
  const [missedReports, setMissedReports] = useState([]);

  const processAppointments = () => {
    const todayDate = dayjs().format("YYYY-MM-DD");

    // Flatten and filter out any null/undefined items
    const allAppointments = Object.values(filteredAppointment || {}).flat().filter(Boolean);

    // Today's appointments
    const todays = allAppointments.filter(
      (appt) =>
        appt.date === todayDate &&
        new Date(`${appt.date}T${appt.startTime}`) >= new Date()
    );

    // Missed Reports: completed + no url

    //
    const now = moment();

    let filter = allAppointments.filter((item) => {
      const appointmentDateTime = moment(
        `${item.date} ${item.startTime}`,
        "YYYY-MM-DD HH:mm:ss"
      );

      const isTimePassed = appointmentDateTime.isBefore(now);
      const isStudentMissing =
        item.studentJoined === null || item.studentJoined === false;
      const isCounsellorMissing =
        item.counsellorJoined === null || item.counsellorJoined === false;

      return (
        (item.status === "SCHEDULED" ||
          item.status === "COUNSELOR_UNAVAILABLE") &&
        isTimePassed &&
        (isStudentMissing || isCounsellorMissing)
      );
    });
    //

    setTodayAppointments(todays);
    setTotalAppointments(allAppointments.length);
    setMissedReports(filter);
  };

  useEffect(() => {
    processAppointments();
  }, [filteredAppointment]);
  return (
    <div className="p-0 h-full">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 h-full">
        <StatCard
          icon={CalendarCheck}
          tone="blue"
          badge={dayjs().format("DD MMM")}
          value={todayAppointments.length}
          title="Today's Appointments"
          sub1={`1`}
          sub2={`2`}
        />
        <StatCard
          icon={CalendarDays}
          tone="teal"
          value={totalAppointments}
          title="Total Appointments"
          sub1={`0`}
          sub2={`0`}
        />
        <StatCard
          icon={CalendarX}
          tone="orange"
          value={missedReports.length}
          title="Missed Appointments"
          sub1={`0`}
          sub2={`0`}
        />
      </div>
    </div>
  );
};

export default Index;
